import React from 'react';
import { Link } from 'react-router-dom';

// Slider or Carousel
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay,
    EffectCube,
  } from "swiper";

  // Illustrations
import IntroImg from '../../assets/connect from anywhere.svg';
import Slide1 from '../../assets/cafe conversation 2.svg';
import Slide2 from '../../assets/Watercooler conversation.svg';

import { Button } from '@material-ui/core';
import getSymbolFromCurrency from 'currency-symbol-map';
// icons 
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';

import gtag from 'ga-gtag'

const HiLite = () => {

    //Google Analytics event
    gtag('event','Entered_hi_lite_page')

    return(
        <div className='hiLite-page'>
            <div className='hiLite-intro-section'>
                <div className='hiLite-intro-Logo-container'>
                    <div className="hiLite-intro-Logo active-section fade-bottom"> </div>
                </div>
                <div className='hiLite-intro-text-container'>
                    <div  className='hiLite-intro-text'>
                        Chai Pe Charcha <br /> @Work
                        {/* <div class="content">
                            <div class="content__container">
                                <p class="content__container__text">
                                    @
                                </p>
                                <ul class="content__container__list">
                                    <li class="content__container__list__item">Work !</li>
                                    <li class="content__container__list__item">Cafe !</li>
                                    <li class="content__container__list__item">Home !</li>
                                    <li class="content__container__list__item">EveryWhere !</li>
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className='hiLite-why-section'>
                <div className='hiLite-why-container'>
                    <div className='hiLite-why-text'>
                        Missing a lite hi @ work? check out hiLite. <br />
                        <Link to='/hiLite' className='learnMore'>Learn more</Link>
                    </div>
                    <div className='hiLite-why-slider'>
                        <Swiper
                            slidesPerView={1}
                            loop={true}
                            autoplay={{ delay: 4000 }}
                            className="slides"
                        >
                            <SwiperSlide>
                                <div className='hiLite-why-slide-image-container'>
                                    <img src={Slide1} className='hiLite-why-slide-image' alt='SlideImage'/>
                                </div> 
                                {/* <div className='hiLite-why-slide-text'>
                                    Boundaryless organization level communication and collaboration.
                                </div> */}
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='hiLite-why-slide-image-container'>
                                    <img src={Slide2} className='hiLite-why-slide-image' alt='SlideImage'/>
                                </div>
                                {/* <div className='hiLite-why-slide-text'>
                                    Uninterrupted communication even in poor bandwconditions.
                                </div> */}
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
                {/* <div className='hiLite-why-second'>
                </div> */}
            </div>
            {/* <div className='hiLite-features-section'>
                <div className='hiLite-features-video-container'>
                    <div className='hiLite-features-video-slider'></div>
                </div>
                <div className='hiLite-features-details reveal fade-right'>
                    <div className='hiLite-features-title'>
                        Features
                    </div>
                    <div className='hiLite-features-list'>
                        <ul>
                            <li>feature 1</li>
                            <li>feature 1</li>
                            <li>feature 1</li>
                        </ul>
                    </div>
                </div>
            </div> */}
            <div className='hiLite-plans-section'>
                {/* <div className='hiLite-plans-container reveal fade-bottom'>
                    <div className='price-plans'>
                        <h3 className='planName'>Basic</h3>
                        <div className='planPrice'>
                            <h1>Free</h1> 
                            <h3>/month /registration</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 1</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 2</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 3</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            <Button className='planButton' variant="outlined" color="primary">Sign up</Button>
                        </div>
                    </div>
                    <div className='price-plans'>
                        <h3 className='planName'>Pro</h3>
                        <div className='planPrice'>
                            <h1>{getSymbolFromCurrency('INR')}400</h1> 
                            <h3>/month /subscription</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 1</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 2</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 3</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 4</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 5</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            <Button className='planButton' variant="outlined" color="secondary">Pay now</Button>
                        </div>
                    </div>
                </div> */}
                <div className='plans-comingSoon reveal fade-bottom'>
                    "Coming Soon"
                </div>
            </div>
        </div>
    )
}

export default HiLite;